import Tooltip from '@material-ui/core/Tooltip';
import {
    createTheme, MuiThemeProvider
} from '@material-ui/core/styles';

const theme = createTheme({
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontFamily: 'Hind',
                fontSize: '14px',
                fontWeight: 500,
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: '1.29'
            }
        }
    }
});

export const CustomToolTip = (props) => {
    return (
        <MuiThemeProvider theme={theme}  data-cy="CustomTooltip">
            <Tooltip title={props.title} placement={props.placement} interactive={props.interactive} data-cy="CustomTooltip-Tooltip">
                {props.children}
            </Tooltip>
        </MuiThemeProvider>
    );
};
